import { jsxs as e, jsx as a } from "react/jsx-runtime";
import { CloseButton as o } from "../CloseButton/CloseButton.js";
import '../../assets/Header.css';const l = "_header_1yk10_1", c = "_appInfo_1yk10_12", r = "_appIcon_1yk10_17", _ = "_appTitleContainer_1yk10_26", d = "_appTitle_1yk10_26", m = "_appSubtitle_1yk10_43", p = {
  header: l,
  appInfo: c,
  appIcon: r,
  appTitleContainer: _,
  appTitle: d,
  appSubtitle: m
}, T = ({
  appIconPath: t,
  copySubtitle: n,
  copyTitle: s,
  onClose: i
}) => /* @__PURE__ */ e("div", { className: `${p.header} iOSPWA-header`, children: [
  /* @__PURE__ */ e("div", { className: p.appInfo, children: [
    /* @__PURE__ */ a("img", { className: p.appIcon, src: t }),
    /* @__PURE__ */ e("div", { className: p.appTitleContainer, children: [
      /* @__PURE__ */ a("span", { className: p.appTitle, children: s }),
      /* @__PURE__ */ a("span", { className: p.appSubtitle, children: n })
    ] })
  ] }),
  /* @__PURE__ */ a(o, { onClose: i })
] });
export {
  T as Header
};
